<template>
  <b-tab title="Aanvragen">
    <b-row>
      <b-col cols="8">
        <h5>Overzicht van recente aanvragen</h5>
        <hr>
      </b-col>
      <b-col cols="4">
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-table bordered responsive
                 :items="requests">
        </b-table>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            value: {},
            isLoading: {
                type: Boolean,
                default: false,
            },
            requests: {
              type: Array,
              default: [],
            }
        },

        data() {
            return {
            };
        },

        computed: {
        },

        methods: {
        },

        watch: {
        },
    }
</script>
